module.exports = __webpack_public_path__ + "robotboy_3-4dc60c7a010688ceec584006b0b7fe20.png";